import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CheckBoxIcon } from "../../../assets/img/icon/check_box_black_24dp.svg";
import { ReactComponent as ChevronRight } from "../../../assets/img/icon/chevron_right_black_24dp.svg";
import { ReactComponent as DashboardIcon } from "../../../assets/img/icon/dashboard_black_24dp.svg";
import { ReactComponent as Description } from "../../../assets/img/icon/description_black_24dp.svg";
import { ReactComponent as CheckBoxIconBlank } from "../../../assets/img/icon/disabled_by_default_black_24dp.svg";
import { ReactComponent as Equalizer } from "../../../assets/img/icon/equalizer_black_24dp.svg";
// import { ReactComponent as Groups } from "../../../assets/img/icon/groups_black_24dp.svg";
import { ReactComponent as MaskIcon } from "../../../assets/img/icon/masks_black_24dp.svg";
import { ReactComponent as People } from "../../../assets/img/icon/people_black_24dp.svg";
import { ReactComponent as PieChart } from "../../../assets/img/icon/pie_chart_black_24dp.svg";
import { ReactComponent as ViewList } from "../../../assets/img/icon/view_list_black_24dp.svg";
import { COLOR, GRAPH_COLOR } from "../../../config/constant";
import { generateGraphData, getDateFormat } from "../../../helpers/helper";
import { Patient } from "../../../models/Patient";
import { Record } from "../../../models/Record";
import { getDevice } from "../../../services/httpService/deviceRequest";
import {
  getPatient,
  getPatientCount,
} from "../../../services/httpService/patientRequest";
import {
  getRecord,
  getRecordCount,
  getRecordReviewedRatio,
} from "../../../services/httpService/recordRequest";
import { GlobalContext } from "../../contexts/globalContext";
import AnimatedBlock from "../../ui/atoms/AnimatedBlock/AnimatedBlock";
import CardDashboard from "../../ui/atoms/CardDashboard/CardDashboard";
import ChartBar from "../../ui/atoms/ChartBar/ChartBar";
import ChartPie from "../../ui/atoms/ChartPie/ChartPie";
import PageTitle from "../../ui/atoms/PageTitle/PageTitle";

const cards = [
  {
    label: "pasien",
    icon: (
      <People className="w-10 md:w-12 h-10 md:h-12 fill-current text-primary" />
    ),
    path: "/patient",
  },
  {
    label: "rekam",
    icon: (
      <Description className="w-10 md:w-12 h-10 md:h-12 fill-current text-primary" />
    ),
    path: "/record",
  },
  {
    label: "perangkat",
    icon: (
      <MaskIcon className="w-10 md:w-12 h-10 md:h-12 fill-current text-primary" />
    ),
    path: "/device",
  },
  // {
  //   label: "mitra",
  //   icon: <Groups  className="w-10 md:w-12 h-10 md:h-12 fill-current text-primary" />,
  //   path: "/partner",
  // },
];
let prev7Date = new Date();
prev7Date.setDate(prev7Date.getDate() - 7);
let formattedPrev7Date = getDateFormat(prev7Date);

const Dashboard = () => {
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState(new Array(5).fill(0));
  const [patients, setPatients] = useState(new Array(5).fill(0));
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [value, setValue] = useState({
    mitra: "",
    pasien: "",
    rekam: "",
    perangkat: "",
    recordRatio: [],
  });

  const [dataCount, setDataCount] = useState({
    patient: [],
    record: [],
  });

  const handleGetData = async () => {
    try {
      // FETCH DATA
      const [record, patient, device, patientStat, recordStat, recordRatio] =
        await Promise.all([
          getRecord(
            `limit=5&fields=patient,createdAt,testNumber,notes,device,mode`
          ),
          getPatient(`doctor=${sharedState.user._id}&limit=5`),
          getDevice(`doctor=${sharedState.user._id}&limit=5`),
          getPatientCount(
            `doctor=${sharedState.user._id}&startDate=${formattedPrev7Date}`
          ),
          getRecordCount(
            `doctor=${sharedState.user._id}&startDate=${formattedPrev7Date}`
          ),
          getRecordReviewedRatio(`doctor=${sharedState.user._id}`),
        ]);

      const recordData = record.result.map(
        (res) =>
          new Record(
            res._id,
            res.createdAt,
            res.device,
            res.mode,
            res.patient,
            res.notes,
            res.testNumber
          )
      );
      const patientData = patient.result.map(
        (res) => new Patient(res._id, res.user.name, res.user.profile)
      );

      if (!isMounted.current) return;
      setRecords(recordData);
      setPatients(patientData);
      setValue((prevState) => ({
        ...prevState,
        rekam: record.count,
        pasien: patient.count,
        perangkat: device.count,
        recordRatio: [
          { name: "Sudah Direview", value: recordRatio.result.reviewedRecord },
          {
            name: "Belum Direview",
            value: recordRatio.result.unreviewedRecord,
          },
        ],
      }));

      setFirstNotif(record.count + patient.count + device.count);

      const patientGraphData = await generateGraphData(
        new Date(prev7Date),
        patientStat.result
      );

      const recordGraphData = await generateGraphData(
        new Date(prev7Date),
        recordStat.result
      );

      setDataCount({
        patient: patientGraphData,
        record: recordGraphData,
      });
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      if (isMounted.current) setLoading(false);
    }
  };

  const setFirstNotif = (count) => {
    if (sessionStorage.getItem("respinosFirstLogin") !== "true") {
      const message =
        count === 0 ? (
          <div>
            Selamat datang {sharedState.user.name} di aplikasi web respinos.
            Silakan tambahkan{" "}
            <Link to="/patient">
              <span className="text-primary"> pasien </span>{" "}
            </Link>{" "}
            dan{" "}
            <Link to="/device">
              <span className="text-primary">perangkat</span>
            </Link>{" "}
            untuk memulai.
          </div>
        ) : (
          <div>
            Selamat datang kembali {sharedState.user.name} di aplikasi{" "}
            <span className="text-primary"> web respinos</span>.
          </div>
        );
      setTimeout(() => {
        dispatch("toast", message);
        sessionStorage.setItem("respinosFirstLogin", "true");
      }, 3000);
    }
  };

  useEffect(() => {
    handleGetData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Dashboard"
          description="Selamat datang di aplikasi website resmi respinos."
          icon={
            <DashboardIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />

        <div className="mt-12 md:mt-16">
          <div className="grid grid-cols-12 gap-3">
            {cards.map((card) => (
              <div
                key={"card-" + card.label}
                className="col-span-6 lg:col-span-4 xl:col-span-3 border border-primary px-1.5 md:px-3 py-1 md:py-2 rounded-lg shadow-lg hover:bg-primary hover:bg-opacity-20 cursor-pointer"
              >
                {loading ? (
                  <div className="flex space-x-2 md:space-x-3 items-center">
                    <div className="flex-shrink-0 w-10 md:w-12 h-10 md:h-12 bg-primary rounded-full animate-pulse" />
                    <div className="w-full ">
                      <AnimatedBlock className="w-1/2 h-5" />
                      <AnimatedBlock className="w-full mt-1 h-5" />
                    </div>
                  </div>
                ) : (
                  <Link to={`${card.path}`}>
                    <div className="flex space-x-2 md:space-x-3 items-center">
                      <div className="w-10 md:w-12 flex-shrink-0 ">
                        {card.icon}
                      </div>
                      <div className="text-primary">
                        <div className="text-sm capitalize text-primary text-opacity-50">
                          {card.label}
                        </div>
                        <div className="text-base md:text-lg leading-tight md:leading-normal">
                          {value[card.label] || "-"}
                        </div>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-5">
          <CardDashboard
            title="Grafik Jumlah Pasien Baru"
            icon={<Equalizer fill={"#fafafa"} className="w-5 h-5" />}
            className="col-span-12 lg:col-span-8"
          >
            <div>
              {loading ? (
                <>
                  <AnimatedBlock className="mt-3 mb-1 h-48" />
                  <AnimatedBlock className="my-2 h-6" />
                </>
              ) : dataCount.patient.length !== 0 ? (
                <div className="h-56 text-xs md:text-sm">
                  <ChartBar
                    data={dataCount.patient}
                    dataXKey={"_id"}
                    dataYKey={["count"]}
                    // fill={GRAPH_COLOR[8]}
                  />
                </div>
              ) : (
                <div className="pt-2.5">Tidak dapat menampilkan data</div>
              )}
            </div>
          </CardDashboard>

          <CardDashboard
            title="Pasien Terbaru"
            icon={<ViewList fill={"#fafafa"} className="w-5 h-5" />}
            className="col-span-12 lg:col-span-4"
          >
            <div className="overflow-x-auto">
              <table className="w-full mt-5">
                <tbody>
                  {patients.map((patient, idx) => {
                    if (patient._id === undefined)
                      return (
                        <tr className="" key={"patients-" + idx}>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                        </tr>
                      );
                    return (
                      <tr
                        key={"patient-" + patient._id}
                        className={"border-b  " + (idx === 0 ? "border-t" : "")}
                      >
                        <td className="px-1 py-1">{patient.name}</td>
                        <td className="px-1 py-1">
                          {patient.profile.age
                            ? `${patient.profile.age} Tahun`
                            : "-"}{" "}
                        </td>
                        <td className="px-1 py-1">
                          <Link to={`/patient/${patient._id}`}>
                            <div className="px-1 py-0.5 text-sm border border-primary text-primary rounded inline-block">
                              Lihat
                            </div>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {patients.length !== 0 ? (
              <Link to="/patient">
                <div className="mt-2 flex items-center">
                  Lihat lebih banyak
                  <ChevronRight fill={COLOR.PRIMARY} className="w-5 h-5" />
                </div>
              </Link>
            ) : (
              <div className="pb-3">Data tidak ditemukan</div>
            )}
          </CardDashboard>
        </div>

        <div className="mt-6 grid grid-cols-12 gap-5">
          <CardDashboard
            title="Grafik Jumlah Pengukuran"
            icon={<Equalizer fill={"#fafafa"} className="w-5 h-5" />}
            className="col-span-12 lg:col-span-8"
          >
            <div>
              {loading ? (
                <>
                  <AnimatedBlock className="mt-3 mb-1 h-48" />
                  <AnimatedBlock className="my-2 h-6" />
                </>
              ) : dataCount.record.length !== 0 ? (
                <div className="h-56 text-xs md:text-sm">
                  <ChartBar
                    data={dataCount.record}
                    dataXKey={"_id"}
                    dataYKey={["count"]}
                    fill={GRAPH_COLOR[3]}
                  />
                </div>
              ) : (
                <div className="pt-2.5">Tidak dapat menampilkan data</div>
              )}
            </div>
          </CardDashboard>

          <CardDashboard
            title="Status Pengukuran"
            icon={<PieChart fill={"#fafafa"} className="w-5 h-5" />}
            className="col-span-12 lg:col-span-4"
          >
            <div>
              {loading ? (
                <>
                  <AnimatedBlock className="mt-3 mb-1 h-48" />
                  <AnimatedBlock className="my-2 h-6" />
                </>
              ) : dataCount.record.length !== 0 ? (
                <div className="h-56 text-xs md:text-sm">
                  <ChartPie data={value.recordRatio} />
                </div>
              ) : (
                <div className="pt-2.5">Tidak dapat menampilkan data</div>
              )}
            </div>
          </CardDashboard>
        </div>

        <div className="mt-6 grid grid-cols-12">
          <CardDashboard
            title="Pengukuran Terakhir"
            icon={<ViewList fill={"#fafafa"} className="w-5 h-5" />}
            className="col-span-12"
          >
            <div className="overflow-x-auto">
              <table className="w-full mt-5">
                <tbody>
                  {records.map((record, idx) => {
                    if (record._id === undefined)
                      return (
                        <tr className="" key={"dummy-record-" + idx}>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                          <td className="px-1 py-1">
                            <AnimatedBlock className="h-6" />
                          </td>
                        </tr>
                      );
                    return (
                      <tr
                        key={"record-" + record._id}
                        className={"border-b  " + (idx === 0 ? "border-t" : "")}
                      >
                        <td className="px-1 py-1">{record.createdAt}</td>
                        <td className="px-1 py-1">{record.patient.name}</td>
                        <td className="px-1 py-1">{`Tes ke-${record.testNumber}`}</td>
                        <td className="px-1 py-1">{record.mode}</td>
                        <td className="px-1 py-1">{record.device}</td>
                        <td className="px-1 py-1">
                          {record.isReviewed ? (
                            <CheckBoxIcon className="w-5 h-5 fill-current text-primary" />
                          ) : (
                            <CheckBoxIconBlank className="w-5 h-5 fill-current text-gray-400" />
                          )}
                        </td>
                        <td className="px-1 py-1">
                          <Link to={`/record/${record._id}`}>
                            <div className="inline-block px-1 py-0.5 text-sm border border-primary text-primary rounded">
                              Lihat
                            </div>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {records.length !== 0 ? (
              <Link to="/record">
                <div className="mt-2 flex items-center">
                  Lihat lebih banyak
                  <ChevronRight fill={COLOR.PRIMARY} className="w-5 h-5" />
                </div>
              </Link>
            ) : (
              <div className="pb-3">Data tidak ditemukan</div>
            )}
          </CardDashboard>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
